import { render, staticRenderFns } from "./detailbunga.vue?vue&type=template&id=4f67f6e4&"
import script from "./detailbunga.vue?vue&type=script&lang=js&"
export * from "./detailbunga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports